import { lazy } from 'react';

const List = lazy(() => import('./list'));
const Edit = lazy(() => import('./form/edit'));
const Create = lazy(() => import('./form/create'));

export { List, Edit, Create };
